import Card from "components/card";
import StackTelasMenu from "./StackTelasMenu";
import { DataGrid } from "@mui/x-data-grid";
import { columns } from "../columns";
import StackTelasDrawer from "./StackTelasDrawer";
import React, { useState, useEffect } from "react";
import { getAllRolls, getAllRollsDelete } from "../functions";
import { Box, CircularProgress, Typography, Button, Autocomplete, TextField } from "@mui/material";
import { useDispatch } from "react-redux";
import StackTelasDelete from "./StackTelasDelete";
import PrintLabelModal from "./print-label-modal";
import { FaTshirt } from "react-icons/fa";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import FilterAltIcon from "@mui/icons-material/FilterAlt";
import DialogReport from "./Dialog-Report";
import DialogReportByCloth from "./DialogReportByCloth";
import DataGridMarifer from "components/dataGridMarifer/dataGridMarifer";
import { getAllTelas } from "../../telas/functions";

const StackTelasTable = () => {
  const [open, setOpen] = useState(false);
  const [openReport, setOpenReport] = useState(false);
  const [openDelete, setOpenDelete] = useState(false);
  const [openPdf, setOpenPdf] = useState(false);
  const [mode, setMode] = useState("POST");
  const [rollsData, setRollsData] = useState([]);
  const [rollsDataDelete, setRollsDataDelete] = useState(null);
  const [dataColumns, setDataColumns] = useState(null);
  const [dataDefault, setDataDefault] = useState(null);
  const [telas, setTelas] = useState([]);
  const [selectedTela, setSelectedTela] = useState(null);
  const [openReportByCloth, setOpenReportByCloth] = useState(false);
  const dispatch = useDispatch();

  const handleClosePdf = () => {
    setOpenPdf(false);
    setDataDefault(null);
  };

  const handleOpenPdf = () => {
    setOpenPdf(true);
  };

  useEffect(() => {
    const fetchData = async () => {
      let rolls = await getAllRolls();
      const sorted = [...(rolls || [])].sort((a, b) => b.id - a.id);
      setRollsData(sorted);
    };

    const fetchDataDelete = async () => {
      let rolls = await getAllRollsDelete();
      setRollsDataDelete(rolls);
    };
    fetchData();
    fetchDataDelete();
    getAllTelas().then((data) => setTelas(data || []));
    let col = columns(
      setOpen,
      setMode,
      setOpenDelete,
      dispatch,
      handleOpenPdf,
      handleClosePdf,
      setDataDefault
    );
    setDataColumns(col);
  }, [open, openDelete, dispatch]);

  const handleClose = () => {
    setOpen(false);
    setOpenReport(false);
  };

  const filteredRolls = selectedTela
    ? rollsData.filter((r) => r.cloth?.name === selectedTela.name)
    : rollsData;

  return (
    <Box sx={{ height: "750px", width: "100%" }}>
      <StackTelasDelete openDelete={openDelete} setOpenDelete={setOpenDelete} />
      <StackTelasDrawer open={open} handleClose={handleClose} mode={mode} />
      <DialogReport
        openReport={openReport}
        handleClose={handleClose}
        rollsData={rollsData}
        rollsDataDelete={rollsDataDelete}
      />
      <DialogReportByCloth
        open={openReportByCloth}
        onClose={() => setOpenReportByCloth(false)}
        rolls={filteredRolls}
        clothName={selectedTela?.name || ""}
      />
      {dataDefault !== null ? (
        <PrintLabelModal
          open={openPdf}
          handleClose={handleClosePdf}
          data={[dataDefault]}
        />
      ) : null}
      <Card extra={"w-full h-full p-4"}>
        <div className="relative flex items-center justify-end">
          <div className="w-full text-xl font-bold text-navy-700 dark:text-white">
            <div className="flex justify-end gap-4 flex-wrap items-center">
              <Autocomplete
                size="small"
                options={telas}
                getOptionLabel={(option) => `${option.name} - ${option.code}`}
                value={selectedTela}
                onChange={(_, val) => setSelectedTela(val)}
                isOptionEqualToValue={(opt, val) => opt.id === val.id}
                sx={{ width: 280 }}
                renderInput={(params) => (
                  <TextField {...params} label="Filtrar por Tela" />
                )}
              />
              <Button
                disabled={!selectedTela}
                onClick={() => setOpenReportByCloth(true)}
              >
                <FilterAltIcon />
                Reporte por Tela
              </Button>
              <Button
                onClick={() => {
                  setMode("POST");
                  setOpen(true);
                }}
              >
                <AddCircleIcon />
                Agregar Nuevo Rollo
              </Button>
              <Button
                onClick={() => {
                  setOpenReport(true);
                }}
              >
                <FileDownloadIcon />
                Descargar Reporte
              </Button>
            </div>
          </div>
        </div>

        {rollsData ? (
          <DataGridMarifer
            rows={filteredRolls || []}
            columns={dataColumns || []}
            initialState={{
              sorting: { sortModel: [{ field: "id", sort: "desc" }] },
            }}
          />
        ) : (
          <div className="flex justify-center pt-56">
            <CircularProgress color="primary" />
            <Typography>Cargando datos...</Typography>
          </div>
        )}
      </Card>
    </Box>
  );
};
export default StackTelasTable;
